import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { AbstractAuditDto, AuditGroupDto, AuditSearchDto, AuditSessionDto, AuditViewDto, DocumentDto, MsisdnDto, ResultListDto, SearchResultDocumentDto, SearchResultMsisdnDto, SubscriberFullDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpAuditService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/audit', authService);
	}

	public getAgentsSessionHistory(agentId: number, pageNumber: number, pageSize: number): Observable<ResultListDto<AuditSessionDto>> {
		return super.doGet(true, `/agent/${agentId}/sessions?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getAgentsSearchHistory(agentId: number, pageNumber: number, pageSize: number): Observable<ResultListDto<AuditSearchDto>> {
		return super.doGet(true, `/agent/${agentId}/searches?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getAgentsViewHistory(agentId: number, pageNumber: number, pageSize: number): Observable<ResultListDto<AuditViewDto>> {
		return super.doGet(true, `/agent/${agentId}/views?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getAgentsModifications(agentId: number, pageNumber: number, pageSize: number): Observable<ResultListDto<AuditGroupDto>> {
		return super.doGet(true, `/agent/${agentId}/modifications?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getViewHistoryOfAgent(agentId: number, pageNumber: number, pageSize: number): Observable<ResultListDto<AuditViewDto>> {
		return super.doGet(true, `/views/agent/${agentId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getViewHistoryOfMsisdn(personId: number, msisdnId: number, pageNumber: number, pageSize: number): Observable<ResultListDto<AuditViewDto>> {
		return super.doGet(true, `/views/subscriber/msisdn/${personId}/${msisdnId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getViewHistoryOfDocument(documentId: number, pageNumber: number, pageSize: number): Observable<ResultListDto<AuditViewDto>> {
		return super.doGet(true, `/views/subscriber/document/${documentId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getViewHistoryOfSubscriber(personId: number, pageNumber: number, pageSize: number): Observable<ResultListDto<AuditViewDto>> {
		return super.doGet(true, `/views/subscriber/full/${personId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getModificationsToAgent(recordId: number, pageNumber: number, pageSize: number): Observable<ResultListDto<AuditGroupDto>> {
		return super.doGet(true, `/modification/agent/${recordId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getModificationsToApproval(recordId: number, pageNumber: number, pageSize: number): Observable<ResultListDto<AuditGroupDto>> {
		return super.doGet(true, `/modification/approval/${recordId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getModificationsToAppRole(recordId: number, pageNumber: number, pageSize: number): Observable<ResultListDto<AuditGroupDto>> {
		return super.doGet(true, `/modification/app_role/${recordId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getModificationsToMasking(pageNumber: number, pageSize: number): Observable<ResultListDto<AuditGroupDto>> {
		return super.doGet(true, `/modification/masking?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getModificationsToPartner(recordId: number, pageNumber: number, pageSize: number): Observable<ResultListDto<AuditGroupDto>> {
		return super.doGet(true, `/modification/partner/${recordId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
	public getModificationsToProperty(pageNumber: number, pageSize: number): Observable<ResultListDto<AuditGroupDto>> {
		return super.doGet(true, `/modification/property?pageNumber=${pageNumber}&pageSize=${pageSize}`);
	}
}
